export const timeIntervals = [
  "Pre-Anesthesia Vital Signs", "Time", "Adm",
  "15 min", "30 min", "45 min", "1 hr", "2 hr", "3 hr", "4 hr", "Discharge"
];

export const categories = [
  { 
    name: "Circulation", 
    options: [
      "Blood pressure >50mmHg of normal (0)", 
      "Blood pressure ±20-50mmHg of normal (1)", 
      "Blood pressure ±20mmHg of normal (2)"
    ] 
  },
  { 
    name: "Oxygenation", 
    options: [
      "SpO2 <90% on oxygen (0)", 
      "SpO2 >90% on oxygen (1)", 
      "SpO2 >92% on room air (2)"
    ] 
  },
  { 
    name: "Respiration", 
    options: [
      "Apnea (0)", 
      "Dyspnea, shallow breathing (1)", 
      "Breathes deeply & coughs freely (2)"
    ] 
  },
  { 
    name: "Consciousness", 
    options: [
      "Not responsive (0)", 
      "Arousable on calling (1)", 
      "Fully awake (2)"
    ] 
  },
  { 
    name: "Activity", 
    options: [
      "No movement (0)", 
      "Moves two extremities (1)", 
      "Moves all extremities (2)"
    ] 
  },
];

export const timeValues = {
  "15 min": 15,
  "30 min": 30,
  "45 min": 45,
  "1 hr": 60,
  "2 hr": 120,
  "3 hr": 180,
  "4 hr": 240
};

export const surgeryProcedureOptions = [
  "Appendectomy",
  "Cholecystectomy",
  "Hernia Repair",
  "Knee Replacement"
];

export const anesthesiaOptions = [
  "General Anesthesia",
  "Spinal Anesthesia",
  "Epidural",
  "Local Anesthesia"
];
